import React, { useEffect } from "react";
import Modal from "react-modal";

Modal.setAppElement("#root");

export default function EC_Modal({
  isOpen,
  children,
  closeModal,
  title,
  styleTop,
  styleLeft,
  styleUnit,
}) {
  let styleModel = {
    content: {
      position: "fixed",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      backgroundColor: "var(--blackText-100)",
      // backgroundImage: "var(--shadeblacklinear)",
      height: "max-content",
      width: "max-content",
      maxWidth: "75%",
      maxHeight: "75%",
      borderRadius: "1rem",
      padding: "10px",
      overflow: "auto",
      outline:"1px solid #ffffff33",
    },
    overlay: { backgroundColor: 'rgba(0, 0, 0, 0.55)' }
  };
  if (styleTop) {
    styleModel.content.top = styleTop + (styleUnit || "%");
  }
  if (styleLeft) {
    styleModel.content.left = styleLeft + (styleUnit || "%");
  }
  useEffect(() => {
    const handleKeydown = (e) => {
      if (isOpen && e.key === "Enter") {
        closeModal();
      }
    };
    if (isOpen) {
      window.addEventListener("keydown", handleKeydown);
    }
    return () => {
      window.removeEventListener("keydown", handleKeydown);
    };
  }, [isOpen, closeModal]);

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={closeModal}
      style={styleModel}
      className="ecModal"
    >
      <div >
        <div
          className="border-b FontFamily-Avenir text-xl flex justify-between text-white p-2 pr-4"
          style={{
            position: "sticky",
            top: 0,
            zIndex: 1,
            
          }}
        >
          <span className="text-lg manrope-800">{title}</span>
          <span className="text-lg manrope-400" onClick={closeModal} style={{color: "white", cursor: "pointer", backgroundColor:' var(--ShadeGray800)', textAlign:'center', borderRadius: '4px', padding: '3px 10px' }}>
          &#10005;
          </span>
        </div>
        <div>{children}</div>
      </div>
    </Modal>
  );
}
